export default __webpack_public_path__ + "static/smu_class1-5cf1fe5972f54ebbe12f72c34010dd27.jpg";